//全局变量
var API_URL = process.env.ADMIN_API;
var dict = {
  //全局字典
  ADMIN_URL: API_URL, //API具体路径
};
export {
  dict
};



// WEBPACK FOOTER //
// ./src/utils/base.js